import React, { useState } from "react";
import "./Prebuildpc.css";

function CustomDropdown({ label, name, value, onChange, options }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="dd-wrapper">
      <label>{label}</label>

      <div className="dd-box" onClick={() => setOpen(!open)}>
        {value || "All"}
        <span className="arrow">▾</span>
      </div>

      {open && (
        <ul className="dd-menu">
          {options.map((opt) => (
            <li
              key={opt.value}
              className={value === opt.value ? "selected" : ""}
              onClick={() => {
                onChange({ target: { name, value: opt.value } });
                setOpen(false);
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function PrebuildPC({ cartCount, setCartCount, wishlistCount, setWishlistCount }) {
  
  // ------- STATIC PRODUCT LIST --------
  const products = [
    {
      id: 1,
      name: "Desktop PC | Core i7-4790 CPU+ Clocite Fan+ 8GB RAM+ 256GB NVMeSSD | HDMI | VGA |1Gbps LAN | USB 3.0+HD Graphics|Windows 11 ProLicense+MS Office(Tower PC-i7+8GB RAM+SSD 256GB/Solar)",
      price: 16099,
      cpu: "i7",
      ssd: "256GB",
      gpu: "HD Graphics",
      image: "https://m.media-amazon.com/images/I/51bXa1jE4NL._SX679_.jpg"
    },
    {
      id: 2,
      name: "Desktop PC|CPU Core i7-4790|8GB RAM|512GB Nvme SSD|HDMI|VGA|1Gbps LAN|USB 3.0|HD Graphics|Windows 11Pro License+MSOffice(Clocite Fan, TowerPC i7,512GB SSD,8GBRAM),Black",
      price: 18299,
      cpu: "i7",
      ssd: "512GB",
      gpu: "HD Graphics",
      image: "https://m.media-amazon.com/images/I/51bXa1jE4NL._SX679_.jpg"
    },
    {
      id: 3,
      name: "Desktop PC |Core i7-4790 CPU | Clocite Fan+ 8GB RAM| 1TB NVMeSSD | HDMI | VGA |1Gbps LAN | USB 3.0+HD Graphics|Windows 11 ProLicense+MS Office(Tower PC-i7+8GB RAM+SSD 1TB/Solar)",
      price: 21099,
      cpu: "i7",
      ssd: "1B",
      gpu: "HD Graphics",
      image: "https://m.media-amazon.com/images/I/51bXa1jE4NL._SX679_.jpg"
    },
    {
      id: 4,
      name: "Desktop PC, Core i7-4770/90 || 16GB RAM || 256GB SSD M.2 NVMe || HDMI, VGA, Gigabit LAN,USB 3.0,HD Graphics,Windows11 Pro Licence(Clocite CPU Fan-PC i7_256GB_SSD,16GB RAM/Cosmic)",
      price: 16199,
      cpu: "i7",
      ssd: "256GB",
      gpu: "HD Graphics",
      image: "https://m.media-amazon.com/images/I/61EoBpp45DL._SX679_.jpg"
    },
    {
      id: 5,
      name: "Desktop PC,Core i7-4770/90 Turbo | 16GB RAM | 512GB SSD M.2 NVMe | HDMI, VGA, Gigabit LAN,USB 3.0,HD Graphics,Windows11 Pro Licence (ClociteFAN-i7-512GB SSD NVMe-16GB-Cosmic)",
      price: 19499,
      cpu: "i7",
      ssd: "512G",
      gpu: "HD Graphics",
      image: "https://m.media-amazon.com/images/I/61EoBpp45DL._SX679_.jpg"
    },
    {
      id: 6,
      name: "Desktop PC, CPU i7-4770/90 Turbo || 16GB RAM || 1TB SSD 4.0 NVMe  ||  HDMI,  VGA, Gigabit LAN,USB 3.0, HD Graphics,  Windows11 Pro Licence,  MS Office(Clocite Fan - i7-1TB SSD-16GB RAM/Cosmic)",
      price: 22499,
      cpu: "i7",
      ssd: "1TB",
      gpu: "HD Graphics",
      image: "https://m.media-amazon.com/images/I/61EoBpp45DL._SX679_.jpg"
    },
    {
      id: 7,
      name: "Desktop PC CL0UDVU || CPU i7-4790 Turbo || 16GB RAM || GPU GT730 4GB || 256GB SSD NVMe|| HDMI,VGA,Giga LAN,USB 3.0+Windows 11 License, MS Office(Clocite Fan,UBIQCOM AC-Cable, VX3-i7/256GBSSD)",
      price: 20999,
      cpu: "i7",
      ssd: "256GB",
      gpu: "GT730",
      image: "https://www.coconutlife.in/cdn/shop/files/VAULTX3.jpg?v=1742631463"
    },
    {
      id: 8,
      name: "Desktop PC | CPU i7-4790 Turbo,Clocite Fan,16GB RAM,GT730 4GB GPU,512GB SSD NVMe | HDMI,VGA,Giga LAN,USB 3.0+Windows 11 License,MS Office(VX3-i7/16GBRAM/512SSD/GT730)",
      price: 22499,
      cpu: "i7",
      ssd: "512GB",
      gpu: "GT730",
      image: "https://www.coconutlife.in/cdn/shop/files/VAULTX3.jpg?v=1742631463"
    },
    {
      id: 9,
      name: "Desktop PC || CPU i7-4790 Turbo || 16GB RAM || GT730 4GB GPU || 1TB SSD NVMe|| HDMI,VGA,Giga LAN,USB 3.0+Windows 11 License,MS Office(VX3-i7/16GBRAM/GT730/1TB)",
      price: 26999,
      cpu: "i7",
      ssd: "1TB",
      gpu: "GT730",
      image: "https://www.coconutlife.in/cdn/shop/files/VAULTX3.jpg?v=1742631463"
    },
    {
      id: 10,
      name: "Desktop PC || CPU i7-4790 Turbo || 16GB RAM || GT730 4GB GPU || 2TB SSD NVMe || HDMI,VGA,Giga LAN,USB 3.0+Windows 11 License, MS Office(VX3-i7/16GBRAM/GT730/2TB)",
      price: 35499,
      cpu: "i7",
      ssd: "2TB",
      gpu: "GT730",
      image: "https://www.coconutlife.in/cdn/shop/files/VAULTX3.jpg?v=1742631463"
    },
    {
      id: 11,
      name: "Desktop PC Core i7-4770, Quadro K2200 4GB GPU +16GB RAM,512GB SSD,HDMI,VGA,1GBs LAN,USB 3.0+Windows 11 License,Closite Fan,(Quadro K2200 4GBGPU/512GB_SSD/RAM16GB/VX4)",
      price: 32499,
      cpu: "i7",
      ssd: "512GB",
      gpu: "Quadro K2200",
      image: "https://m.media-amazon.com/images/I/51Nf8VqFoGL._SX679_.jpg"
    },
    {
      id: 12,
      name: "CPU Desktop PC Core i7-4770, GPU Quadro K2200 4GB+16GB RAM,1TB SSD,HDMI,VGA,1GBs LAN,USB 3.0+Windows 11 License | Trading&Editing (Graphics Card Quadro K2200, 1TB NVMe SSD,16GB Vaultx4)",
      price: 33999,
      cpu: "i7",
      ssd: "1B",
      gpu: "Quadro K2200",
      image: "https://m.media-amazon.com/images/I/51Nf8VqFoGL._SX679_.jpg"
    },
    {
      id: 13,
      name: "Desktop Computer, Core i7-4770, GPU Quadro K2200 4GB+16GB RAM,2TB SSD,HDMI,VGA,1GBs LAN,USB 3.0, Windows 11,MS Office(Trading&Editing Use GPU Quadro K2200, 2TB SSD, 16GB RAM-Vaultx4)",
      price: 40999,
      cpu: "i7",
      ssd: "2TB",
      gpu: "Quadro K2200",
      image: "https://m.media-amazon.com/images/I/51Nf8VqFoGL._SX679_.jpg"
    },
  
  ];

  // ------- FILTER STATES --------
  const [filters, setFilters] = useState({
    price: 150000,
    cpu: "",
    ssd: "",
    gpu: ""
  });

  const handleFilter = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // ------- FILTER LOGIC --------
  const filteredProducts = products.filter((p) => {
    return (
      p.price <= filters.price &&
      (filters.cpu ? p.cpu === filters.cpu : true) &&
      (filters.ssd ? p.ssd === filters.ssd : true) &&
      (filters.gpu ? p.gpu === filters.gpu : true)
    );
  });

  // ------- CART / WISHLIST EFFECT --------
  const handleAddCart = (e) => {
    const img = e.target.closest(".product-card").querySelector("img");
    flyToIcon(img, ".cart-icon");
    setCartCount(prev => prev + 1);
  };

  const handleAddWishlist = (e) => {
    const img = e.target.closest(".product-card").querySelector("img");
    flyToIcon(img, ".wishlist-icon");
    setWishlistCount(prev => prev + 1);
  };

  const flyToIcon = (img, iconSelector) => {
    const flyImg = img.cloneNode(true);
    const imgRect = img.getBoundingClientRect();

    flyImg.style.position = "fixed";
    flyImg.style.top = imgRect.top + "px";
    flyImg.style.left = imgRect.left + "px";
    flyImg.style.width = imgRect.width + "px";
    flyImg.style.height = imgRect.height + "px";
    flyImg.style.transition = "all 0.8s ease-in-out";
    flyImg.style.zIndex = 1000;

    document.body.appendChild(flyImg);

    const target = document.querySelector(iconSelector);
    const targetRect = target.getBoundingClientRect();

    requestAnimationFrame(() => {
      flyImg.style.top = targetRect.top + "px";
      flyImg.style.left = targetRect.left + "px";
      flyImg.style.width = "30px";
      flyImg.style.height = "30px";
      flyImg.style.opacity = 0.5;
    });

    flyImg.addEventListener("transitionend", () => {
      flyImg.remove();
    });
  };

  return (
    <div className="prebuild-container">
      
      {/* FILTERS */}
      <aside className="filters-box">
        <h3>Filter Products</h3>

        <label>Max Price: ₹{filters.price}</label>
        <input
          type="range"
          min="15000"
          max="150000"
          name="price"
          value={filters.price}
          onChange={handleFilter}
        />

        <CustomDropdown
          label="Intel CPU"
          name="cpu"
          value={filters.cpu}
          onChange={handleFilter}
          options={[
            { label: "All", value: "" },
            { label: "Intel i3", value: "i3" },
            { label: "Intel i5", value: "i5" },
            { label: "Intel i7", value: "i7" },
            { label: "Intel i9", value: "i9" }
          ]}
        />

        <CustomDropdown
          label="SSD"
          name="ssd"
          value={filters.ssd}
          onChange={handleFilter}
          options={[
            { label: "All", value: "" },
            { label: "256GB", value: "256GB" },
            { label: "512GB", value: "512GB" },
            { label: "1TB", value: "1TB" },
            { label: "2TB", value: "2TB" }
          ]}
        />

        <CustomDropdown
          label="Graphics Card"
          name="gpu"
          value={filters.gpu}
          onChange={handleFilter}
          options={[
            { label: "All", value: "" },
            { label: "HD Graphics", value: "HD Graphics" },
            { label: "Quadro K2200", value: "Quadro K2200" },
            { label: "GT730", value: "GT730" }
          ]}
        />
      </aside>

      {/* PRODUCTS GRID */}
      <div className="products-grid">
        {filteredProducts.length === 0 ? (
          <p>No products match your filter.</p>
        ) : (
          filteredProducts.map((product) => (
            <div key={product.id} className="product-card">
              <img src={product.image} alt={product.name} />
              <h4>{product.name}</h4>

              <p className="price">
                ₹{product.price.toLocaleString("en-IN")}
              </p>

              <div className="specs">
                <span>CPU: {product.cpu}</span>
                <span>SSD: {product.ssd}</span>
                <span>GPU: {product.gpu}</span>
              </div>

              <div className="pc-actions">
                <i onClick={handleAddWishlist} className="ri-heart-fill"></i>
                <button className="btn" onClick={handleAddCart}>Add to Cart</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
